// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { CREATE_PRODUCT } from "../../graphql/mutations/products/products.mutations";

const useCreateProduct = () => {
  const [createProductMutation, { loading, error, data }] =
    useMutation(CREATE_PRODUCT);

  const createProduct = async (product = {}) => {
    try {
      if (!Object.entries(product).length)
        throw new Error("Product is required");

      const res = await createProductMutation({
        variables: {
          product: {
            ...product,
            retail_price: product.retail_price,
            repairShopr_id: +product?.repairShopr_id || null,
          },
        },
      });
      return res?.data?.createProduct;
    } catch (error) {
      console.error(`Error creating product: ${error?.message}`);
      alert(`Error creating product: ${error?.message}`);
    }
  };

  return { createProduct, loading, error };
};

export default useCreateProduct;
